import StatusChip from '../../../components/StatusChip';
import {
  OVERALL_BUSINESS_PROFILE_STATUS_COLORS,
  OVERALL_BUSINESS_PROFILE_STATUS_LABELS,
} from '../../../constants/businessProfileStatusConstants.jsx';

const BusinessProfileTableStatusChip = ({ status, size = 'small', className, sx }) => {
  const color = OVERALL_BUSINESS_PROFILE_STATUS_COLORS[status];
  const label = OVERALL_BUSINESS_PROFILE_STATUS_LABELS[status];

  if (!status || !color || !label) {
    return '-';
  }

  return <StatusChip color={color} label={label} size={size}  className={className} sx={sx} />;
};

export default BusinessProfileTableStatusChip;
